import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faEarthAmericas } from '@fortawesome/free-solid-svg-icons';

import LazyModal from 'Components/Utility/LazyModal';
import 'Components/Wishlist/WishlistShareButton.scss';

const WishlistShareModalContainer = lazy(() => import(/* webpackChunkName: "WishlistShareModalContainer" */ 'Containers/Wishlist/WishlistShareModalContainer'));

const messages = defineMessages({
  private: {
    id: 'wishlistsharebutton.private',
    defaultMessage: 'Private',
  },
  public: {
    id: 'wishlistsharebutton.public',
    defaultMessage: 'Public',
  },
});

const WishlistShareButton = ({ authenticated, visibility }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { formatMessage } = useIntl();

  if (!authenticated) return false;
  return (
    <React.Fragment>
      <div className="wishlist-share-button-container">
        <div className="wishlist-share-message">
          {visibility === 'public' ? <FontAwesomeIcon icon={faEarthAmericas} /> : <FontAwesomeIcon icon={faLock} />}
          <FormattedMessage id="wishlistsharebutton.message" defaultMessage="Your wishlist is {privacySetting}" values={{ privacySetting: formatMessage(messages[visibility]) }} />
        </div>
        &nbsp;
        <button
          className="btn wishlist-share-button"
          onClick={() => setModalOpen(!modalOpen)}
        >
          <FormattedMessage id="wishlistsharebutton.share" defaultMessage="Edit/Share" />
        </button>
      </div>
      <LazyModal
        centered
        hasCloseIcon={false}
        hasCloseFooter={false}
        open={modalOpen}
        setOpen={setModalOpen}
        className="two-pane-modal"
      >
        <WishlistShareModalContainer setOpen={setModalOpen} />
      </LazyModal>
    </React.Fragment>
  );
};

WishlistShareButton.propTypes = {
  authenticated: PropTypes.bool,
  visibility: PropTypes.string,
};
WishlistShareButton.defaultProps = {
  authenticated: false,
  visibility: 'private',
};

const mapStateToProps = ({
  auth: { authenticated },
  auth: {
    wishlist_visibility: visibility,
  },
}) => ({
  authenticated,
  visibility,
});

export default connect(mapStateToProps)(WishlistShareButton);
